import React from "react";
import EvServices from "@/components/EvServices";
import HvInvestment from "@/components/HvInvestment";

export default function EvPage() {
  return (
    <>
      <EvServices />
      <HvInvestment />
    </>
  );
}
